import { render, staticRenderFns } from "./ShowApartment.vue?vue&type=template&id=277ed672&scoped=true&"
import script from "./ShowApartment.vue?vue&type=script&lang=js&"
export * from "./ShowApartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ed672",
  null
  
)

export default component.exports